//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {}
  },
}
